import BricksFetch from "./BricksFetch";
import BricksPOST from "./BricksPOST";
import post_icon from '../../static/admin_icons/AddBrick.svg'
import { useState } from "react";

function BrickController() {
    const [showBrickPost,setShowBrickPost] = useState(false)
    const [showPlus, setShowPlus] = useState(true)
    return (
        <div>{ showPlus ? 
            <div className="post-brick" onClick={e => {
                setShowBrickPost(true)
                setShowPlus(false)
            }}>
                <img src={post_icon} alt="plus-icon"/>
            </div> : 
            <button className = 'close-btn'
            onClick={() => {
                setShowBrickPost(false)
                setShowPlus(true)
            }}>
                Закрыть контекстное меню
            </button>}
            
            { showBrickPost ? (
          <div className="brick-post-card" style={{width:'100%'}}>
            <BricksPOST 
            onShow={e => setShowBrickPost(true)} 
            onHide={e => setShowBrickPost(false)}/>
          </div>
            )
             : '' }
            <BricksFetch/>
        </div>
    );
}

export default BrickController;